// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .card-details {
    display: flex;
    align-items: center;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
  }
  .card-border {
    border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    object-fit: contain;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    width: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
  }
  .cashapp-afterpay-wrapper {
    height: 32px;
    width: 50px;
    border-radius: 4px;
    border: 1px solid #d8d8d8;
    background: #101010;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cashapp-afterpay-button {
    width: 42px;
    height: 10px;
    flex-shrink: 0;
  }
`;

export default styles;
